// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  addPortfolio: () => void,
  setupAddPortfolioForm: () => void,
  showEditModal: (props: ModalProps) => void,
  l: Language,
}

const RawAddPortfolioButton = (props: Props) =>
  <button id="add_new_portfolio"
    className="btn btn-success"
    onClick={() => {
      props.setupAddPortfolioForm()
      props.showEditModal({
        title: 'Add new portfolio',
        onConfirm: props.addPortfolio,
      })
    }}
  >
    {props.l('Add new portfolio')}
  </button>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawAddPortfolioButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/add-portfolio-button.js